import { useQuery } from '@tanstack/react-query';
import { policiesService } from '../../../services/policies';

export function useInstallments(policyId: string | undefined) {
  return useQuery({
    queryKey: ['installments', policyId],
    queryFn: async () => {
      if (!policyId) return [];
      const result = await policiesService.getInstallments(policyId);
      if (!result.success || !result.data) return [];
      return result.data;
    },
    enabled: !!policyId,
    staleTime: 5 * 60 * 1000,
  });
}
